import { ArrowRightLeft } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-emerald-400/10 bg-[#050807]">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <span className="w-9 h-9 rounded-xl bg-emerald-400 grid place-items-center text-[#070C0A]">
              <ArrowRightLeft className="w-4.5 h-4.5" strokeWidth={2.5} />
            </span>
            <span className="leading-none">
              <span className="block font-display font-bold text-lg tracking-tight">Alternativ</span>
              <span className="block text-[9px] font-jbmono uppercase tracking-[0.28em] text-emerald-400/80">
                Courtage Énergie &amp; Services
              </span>
            </span>
          </div>
          <p className="text-sm text-slate-500 leading-relaxed max-w-xs">
            Le courtage en énergie nouvelle génération, porté par des managers indépendants
            partout en France.
          </p>
        </div>

        <div>
          <p className="font-jbmono text-[11px] uppercase tracking-[0.3em] text-slate-600 mb-5">Navigation</p>
          <ul className="space-y-3 text-sm">
            {[
              ["Vision", "#vision"],
              ["Manifeste", "#manifeste"],
              ["Simulation", "#simulation"],
              ["Candidater", "#candidater"],
              ["FAQ", "#faq"],
            ].map(([label, href]) => (
              <li key={href}>
                <a href={href} className="text-slate-400 hover:text-emerald-300 transition-colors duration-300">
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-jbmono text-[11px] uppercase tracking-[0.3em] text-slate-600 mb-5">Recrutement 2027</p>
          <p className="text-sm text-slate-400 leading-relaxed">
            7 agences. 7 territoires exclusifs.
            <br />
            <a href="https://candidature.alternativ-france.fr/dossier" className="text-emerald-300 hover:text-emerald-200 transition-colors underline underline-offset-4">
              Recevoir le dossier de candidature
            </a>
          </p>
        </div>
      </div>

      <div className="border-t border-emerald-400/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-600">© 2026 Alternativ — Courtage Énergie &amp; Services. Tous droits réservés.</p>
          <p className="text-xs text-slate-700">Mentions légales — Confidentialité</p>
        </div>
      </div>
    </footer>
  );
}
